import React from 'react'

// COMPONENTS
import KOGPaginationGrid from '@/main/components/shared/paginationGrid/paginationGrid';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';

// REDUX / UTILS
import { getTranslateByKey } from '@/main/services/utils';
import { IntegrationCodeResponse, ProcurementReportScheduleGridResponse, ProcurementReportScheduleResponse } from '@/main/models/response';
import { IntegrationCodeRequest, ProcurementReportScheduleSearchGridRequest } from '@/main/models/request';
import { integrationCodeApi, procurementReportScheduleApi } from '@/main/api';
import { RowHeaderTextCenter } from '@/main/components/shared/styles';

// COMPONENTS & STYLES LOCAL
import * as S from './styles';
import RowDataCheduleReport from './rowReportSchedule/rowReportSchedule';
import { IEditDataSchedule } from '../types';
import { ResolutionsEnum } from '@/main/services/enum/ResolutionsEnum';

interface IGridScheduleReportProps {
  dataGrid: ProcurementReportScheduleGridResponse[];
  formFilters: ProcurementReportScheduleSearchGridRequest | null;
  updateDataEdit: (data: IEditDataSchedule) => void;
  setDataGrid: React.Dispatch<React.SetStateAction<ProcurementReportScheduleGridResponse[]>>;
  getData: (filters: ProcurementReportScheduleSearchGridRequest | Partial<ProcurementReportScheduleSearchGridRequest>, isResetSearch: boolean) => void;
}
function GridScheduleReport({
  dataGrid,
  formFilters,
  updateDataEdit,
  setDataGrid,
  getData
}: IGridScheduleReportProps) {
  const rowsHeader = [
    getTranslateByKey('information.insurer'),
    getTranslateByKey('information.bodyshop'),
    getTranslateByKey('information.vehicle'),
    getTranslateByKey('information.supplier'),
    getTranslateByKey('information.startDate'),
    getTranslateByKey('information.finalDate'),
    getTranslateByKey('information.username'),
    `${getTranslateByKey('information.date')}, ${getTranslateByKey('information.hour').toLowerCase()} ${getTranslateByKey("information.and")} ${getTranslateByKey('information.username').toLowerCase()}`,
    <RowHeaderTextCenter>{getTranslateByKey('information.actions')}</RowHeaderTextCenter>
  ];
  const rowsGroup = [
    '10%', // insurer
    '10%', // bodyshop
    '10%', // vehicle
    '10%', // supplier
    '10%', // startDate
    '10%', // finalDate
    'responsive', // username
    '15%', // date
    '120px',// actions
    // '30%',
  ]
  async function fetchData(request: any) {
    return procurementReportScheduleApi.procurementReportScheduleSearchGrid(request).then(response => response.data);
  }


  function refreshGrid() {
    getData({}, false);
  }

  return (
    <S.Container>
      <KOGPaginationGrid
        showTitleResults
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
        fetchMore={fetchData}
      >
        <BoxGrid
          rowHeaders={rowsHeader}
          sizeColumns={rowsGroup}
          breakpointTable={ResolutionsEnum.desktop}
        >
          {dataGrid.map((item) =>
            <RowDataCheduleReport
              key={item.guidProcurementReportSchedule}
              refreshGrid={refreshGrid}
              updateDataEdit={updateDataEdit}
              scheduleReport={item}
            />
          )}
        </BoxGrid>
      </KOGPaginationGrid>
    </S.Container>
  )
}

export default GridScheduleReport